/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.SITECORE_API_KEY || '{8F041C31-3CCA-4EC8-BFF7-A2C94FE9F055}',
config.sitecoreApiHost = process.env.SITECORE_API_HOST || 'https://cd-www.adfcareers.gov.au',
config.jssAppName = process.env.JSS_APP_NAME || 'ADF',
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge',
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en',
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || 'https://cd-www.adfcareers.gov.au/sitecore/api/graph/edge',
module.exports = config;